import { z } from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import {
  emailAddressSchema,
  requiredTrimmedString,
} from "@/validation/sharedStringFieldSchemas"

const createMerchantGroupUserFormSchema = z.object({
  schemaName: requiredTrimmedString(
    "Schema name is required"
  ),
  firstName: requiredTrimmedString(
    "First name is required"
  ).max(150),
  lastName: requiredTrimmedString(
    "Last name is required"
  ).max(150),
  email: emailAddressSchema("Email is required"),
})

export const useCreateMerchantGroupUserForm = () =>
  useForm({
    validationSchema: toTypedSchema(
      createMerchantGroupUserFormSchema
    ),
  })
